import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTalleresDeUsuario } from 'services/servicioGet';
import { TallerBase } from 'utils/models/types';

interface TalleresDeUsuario {
  talleresUsuario: TallerBase[];
  loadingTalleresUsuario: boolean;
  errorTalleresUsuario: string | null;
}

// Estado inicial del slice
const initialState: TalleresDeUsuario = {
  talleresUsuario: [],
  loadingTalleresUsuario: false,
  errorTalleresUsuario: null,
};

export const fetchTalleresDeUsuario = createAsyncThunk<
  TallerBase[],
  number, // Id del usuario
  { rejectValue: string }
>('talleres/fetchTalleresDeUsuario', async (id, thunkAPI) => {
  try {
    const response = await getTalleresDeUsuario(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar los talleres');
  }
});

// Slice de talleres
const talleresDeUsuarioSlice = createSlice({
  name: 'talleresDeUsuario',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTalleresDeUsuario.pending, state => {
        state.loadingTalleresUsuario = true;
        state.errorTalleresUsuario = null;
      })
      .addCase(fetchTalleresDeUsuario.fulfilled, (state, action) => {
        state.talleresUsuario = action.payload;
        state.loadingTalleresUsuario = false;
      })
      .addCase(fetchTalleresDeUsuario.rejected, (state, action) => {
        state.loadingTalleresUsuario = false;
        state.errorTalleresUsuario = action.payload as string;
      });
  },
});

export default talleresDeUsuarioSlice.reducer;
